export default "__VITE_ASSET__DeoyFVob__"